import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import NodeWrapper from "./NodeWrapper";
import useHandleConnected from "./useHandleConnected";
import { TouchApp } from "@mui/icons-material";

const ButtonNode = memo(({ id, data, isConnectable, selected }) => {
  const getHandleClass = useHandleConnected(id);
  const options = (data?.arrayOption || []).filter(Boolean).slice(0, 3);
  const message = data?.message || "";

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<TouchApp />}
      title="Botoes"
      color="#683AC8"
      bgColor="#FAFBFF"
      noSource
      isConnectable={isConnectable}
      selected={selected}
      minWidth={220}
    >
      {/* Message preview */}
      {message && (
        <div
          style={{
            fontSize: 11,
            color: "#333",
            lineHeight: 1.4,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            maxWidth: 200,
            background: "#F3EEFF",
            borderRadius: 6,
            padding: "5px 8px",
            marginBottom: 8,
            borderLeft: "3px solid #683AC8",
          }}
        >
          {message}
        </div>
      )}

      {/* Button list with handles at node edge */}
      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {options.map((opt) => (
          <div
            key={opt.number}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "6px 12px",
              background: "#fff",
              border: "1.5px solid #683AC8",
              borderRadius: 20,
              fontSize: 11,
              fontWeight: 600,
              color: "#683AC8",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              position: "relative",
            }}
          >
            {opt.value || `Botao ${opt.number}`}
            <Handle
              type="source"
              position={Position.Right}
              id={"a" + opt.number}
              className={getHandleClass("source", "a" + opt.number)}
              style={{
                position: "absolute",
                top: "50%",
                right: -21,
                transform: "translateY(-50%)",
                cursor: "crosshair",
              }}
              isConnectable={isConnectable}
            />
          </div>
        ))}
        {options.length === 0 && (
          <div style={{ fontSize: 11, color: "#999", fontStyle: "italic", padding: "4px 0" }}>
            Nenhum botao adicionado
          </div>
        )}
      </div>

      {/* WhatsApp limit notice */}
      {options.length > 0 && (
        <div style={{ fontSize: 9, color: "#aaa", marginTop: 4, textAlign: "right" }}>
          Max 3 botoes (WhatsApp)
        </div>
      )}
    </NodeWrapper>
  );
});

ButtonNode.displayName = "ButtonNode";
export default ButtonNode;
